import React, { useState } from "react";
// Components
import FiltersList from "../FiltersList";
import HeaderBar from "./components/HeaderBar";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
// types
import { FiltersProps } from "./types";
import { IfetchNotificationsRecipients } from "store/notificationsRecipients/initialState";

export const Filters: React.FC<FiltersProps> = ({ columns }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCloseDiv, setIsCloseDiv] = useState(false);
  const { data } = useSelector<RootState, IfetchNotificationsRecipients>(
    (state) => state?.notificationRecipients
  );

  // Handlers
  const handleToggleDropdown = () => {
    setIsCloseDiv((prevState) => !prevState);
  };

  return (
    <>
      <div className="items-start justify-start w-full gap-2">
        <HeaderBar
          data={data}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handleToggleDropdown={handleToggleDropdown}
          isCloseDiv={isCloseDiv}
        />
        {/* <FiltersList isCloseDiv={isCloseDiv} /> */}
      </div>
    </>
  );
};
